import { EffectRenderer } from "core/Materials/effectRenderer.js";
import { CommandBuffer } from "../command/commandBuffer.js";
/**
 * The internal runtime implementation exposing more information than @see SmartFilterRuntime.
 * This is used internally to render the smart filter.
 *
 * It is not fully exposed publicly to prevent any misuse of the runtime.
 */
export class InternalSmartFilterRuntime {
    /**
     * Instantiates a new smart filter runtime for one given engine.
     * @param engine - the engine to use to render the smart filter
     */
    constructor(engine) {
        this.engine = engine;
        this._resources = [];
        this.commandBuffer = new CommandBuffer();
        this.effectRenderer = new EffectRenderer(engine);
        this.registerResource(this.effectRenderer);
    }
    /**
     * Register a resource to be disposed when the runtime is disposed.
     * @param resource - defines the resource to dispose once the runtime is disposed
     */
    registerResource(resource) {
        this._resources.push(resource);
    }
    /**
     * Registers a command to be executed during the render loop.
     * @param command - defines the command to execute
     */
    registerCommand(command) {
        this.commandBuffer.push(command);
    }
    /**
     * Renders the smart filter.
     * This function will execute all the commands contained int the command buffer.
     */
    render() {
        try {
            const depthTest = this.engine.depthCullingState.depthTest;
            const stencilTest = this.engine.stencilState.stencilTest;
            this.commandBuffer.execute();
            // EffectRenderer.applyEffectWrapper(), which is called by ShaderRuntime._draw(),
            // sets the depth/stencil state, so we need to restore it.
            this.engine.depthCullingState.depthTest = depthTest;
            this.engine.stencilState.stencilTest = stencilTest;
        }
        catch (e) {
            // eslint-disable-next-line no-debugger
            debugger;
        }
    }
    /**
     * Dispose the runtime and all its associated resources
     */
    dispose() {
        for (const resource of this._resources) {
            resource.dispose();
        }
    }
}
//# sourceMappingURL=smartFilterRuntime.js.map